import Footer from '@/pages/footer';
import Header from '@/pages/header'
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React, { useEffect, useState } from 'react'
import styles from "../../../../styles/DocumentDetail.module.css"
import Link from 'next/link';
import SwiperArrow from '@/pages/images/swiperArrow';
import PortalLaptop from '@/pages/images/portalLaptop';
import NotificationPortal from '@/pages/images/notificationPortal';
import Theme from '@/pages/images/theme';
import LoginMethod from '@/pages/images/loginMethod';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import PageSeo from '@/components/seo/PageSeo';

const markDocumentAsViewed = (documentId: number) => {
  if (typeof window !== "undefined") {
    let viewedDocuments = JSON.parse(localStorage.getItem('serviceManagementViewedDocuments') || '[]');
    if (!viewedDocuments.includes(documentId)) {
      viewedDocuments.push(documentId);
      localStorage.setItem('serviceManagementViewedDocuments', JSON.stringify(viewedDocuments));
    }
  }
};

interface ServiceDocumentStep {
  id: number;
  icon: React.ComponentType<{ color?: string }>;
  docNumber: string;
  title: string;
  link: string;
}

const PortalDocument = (_props: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { t } = useTranslation("documentsTranslate");
  const router = useRouter();
  const [viewedDocuments, setViewedDocuments] = useState<number[]>([]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const viewed = JSON.parse(localStorage.getItem('serviceManagementViewedDocuments') || '[]');
      setViewedDocuments(viewed);
      markDocumentAsViewed(1);
      // Update state after marking as viewed
      const updated = JSON.parse(localStorage.getItem('serviceManagementViewedDocuments') || '[]');
      setViewedDocuments(updated);
    }
  }, []);

  const serviceDocumentStep: ServiceDocumentStep[] = [
    {
      id: 1,
      icon: PortalLaptop,
      docNumber: 'Doc 1',
      title: `${t("serviceManagementDocPortalTitle")}`,
      link: '/service-management/documents/portal'
    },
    {
      id: 2,
      icon: LoginMethod,
      docNumber: 'Doc 2',
      title: `${t("serviceManagementDocLoginMethodTitle")}`,
      link: '/service-management/documents/login-method'
    },
    {
      id: 3,
      icon: Theme,
      docNumber: 'Doc 3',
      title: `${t("serviceManagementDocThemeTitle")}`,
      link: '/service-management/documents/content-theme'
    },
    {
      id: 4,
      icon: NotificationPortal,
      docNumber: 'Doc 4',
      title: `${t("serviceManagementDocPortalNotificationTitle")}`,
      link: '/service-management/documents/notification'
    }
  ]

  return (
    <>
      <PageSeo
        title={`${t("serviceManagementDocPortalTitle")} | Stoneity`}
        description={t("serviceManagementDocPortalDescriptionOne")}
        locale={router.locale}
        keywords={router.locale === "tr"
          ? "servis portalı dokümanı, portal yönetimi, Stoneity"
          : "service portal document, portal management, Stoneity"
        }
      />
      <Header />
      <div className={styles.pageFlex}>
        <div className={styles.documentDetailWrapper}>
          <div className={styles.stepWrapper}>
            {serviceDocumentStep.map((docStep, index) => {
              const isDocViewed = viewedDocuments.includes(docStep.id);
              const IconComponent = docStep.icon;
              return (
                <Link key={index} href={docStep.link} className={styles.stepperItem} style={{ width: "auto", flex: "1 1" }} onClick={() => {
                  markDocumentAsViewed(docStep.id);
                  const updated = JSON.parse(localStorage.getItem('serviceManagementViewedDocuments') || '[]');
                  setViewedDocuments(updated);
                }}>
                  <div className={`${styles.stepIconWrapper} ${isDocViewed ? styles.completed : ""}`}>
                    {IconComponent && <IconComponent color={isDocViewed ? "#fff" : "#03555E"} />}
                  </div>
                  <div className={styles.stepName}>{docStep.title}</div>
                  <div className={styles.stepDoc}>{docStep.docNumber}</div>
                </Link>
              )
            })}
          </div>
          <div className={styles.documentDetailTop}>
            <div className={styles.responsiveDocumentCounter}>Doc 1</div>
            <Link className={styles.swiperArrowWrapper} href={'/service-management/documents/notification'} style={{ transform: "rotate(180deg)" }}><SwiperArrow /></Link>
            {t("serviceManagementDocPortalTitle")}
            <Link className={styles.swiperArrowWrapper} href={'/service-management/documents/login-method'}><SwiperArrow /></Link>
          </div>
          <div className={styles.documentDetailPortalBottomWrapper}>
            <div className={styles.documentDetailTextPhaseWrapper}>
              <div className={styles.title}>{t("whatIs")}</div>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <div className={styles.explain}>{t("serviceManagementDocPortalDescriptionOne")}</div>
                <div className={styles.explain}>{t("serviceManagementDocPortalDescriptionTwo")}</div>
              </div>
            </div>
            <div className={styles.documentDetailTextPhaseWrapper}>
              <div className={styles.title}>{t("howToUse")}</div>
              <div className={styles.explain}>{t("serviceManagementDocPortalHowToDescriptionOne")}</div>
              <div className={styles.documentDetailTextPhaseWrapper}>
                <div className={styles.subtaskTitle}>{t("serviceManagementDocPortalHowToUseColumnTabTitle")}:</div>
                <ul>
                  <li>
                    <span>{t("serviceManagementDocPortalHowToUseColumnTitleOne")}:</span>
                    {t("serviceManagementDocPortalHowToUseColumnTextOne")}
                  </li>
                  <li>
                    <span>{t("serviceManagementDocPortalHowToUseColumnTitleTwo")}:</span>
                    {t("serviceManagementDocPortalHowToUseColumnTextTwo")}
                  </li>
                  <li>
                    <span>{t("serviceManagementDocPortalHowToUseColumnTitleThree")}:</span>
                    {t("serviceManagementDocPortalHowToUseColumnTextThree")}
                  </li>
                  <li>
                    <span>{t("serviceManagementDocPortalHowToUseColumnTitleFour")}:</span>
                    {t("serviceManagementDocPortalHowToUseColumnTextFour")}
                  </li>
                  <li>
                    <span>{t("serviceManagementDocPortalHowToUseColumnTitleFive")}</span>
                    <ul>
                      <li>
                        <span>{t("serviceManagementDocPortalHowToUseColumnTitleFiveSubtaskTitleOne")}:</span>
                        {t("serviceManagementDocPortalHowToUseColumnTextFiveSubtaskTitleTextOne")}
                      </li>
                      <li>
                        <span>{t("serviceManagementDocPortalHowToUseColumnTitleFiveSubtaskTitleTwo")}:</span>
                        {t("serviceManagementDocPortalHowToUseColumnTextFiveSubtaskTitleTextTwo")}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || 'en', ['documentsTranslate', 'common'])),
    },
  };
};

export default PortalDocument;
